import { render, staticRenderFns } from "./MergeFieldsGroup.vue?vue&type=template&id=493d076c&scoped=true"
import script from "./MergeFieldsGroup.vue?vue&type=script&lang=js"
export * from "./MergeFieldsGroup.vue?vue&type=script&lang=js"
import style0 from "./MergeFieldsGroup.vue?vue&type=style&index=0&id=493d076c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d076c",
  null
  
)

export default component.exports